import { Grid, Paper, Tooltip, Typography } from "@mui/material";
import dragAndDropImg from "../assets/drag-and-drop.png";
import OcrAppImg from "../assets/OCRApp.png";
import LevitateImg from "../assets/Levitate.png";
import React from "react";

const projects = [
  {
    name: "drag-and-drop",
    description:
      "Drag and drop items that includs inputs and show data on a table when click save",
    link: "https://drag-drop-inputs.netlify.app/",
    image: dragAndDropImg,
  },
  {
    name: "Ocr App",
    description: "Convert image to text",
    link: "https://ocr-online.netlify.app/",
    image: OcrAppImg,
  },
  {
    name: "project 4",
    description: "this project is under construction 4",
    link: "/",
    image: "https://react.dev/images/og-home.png",
  },
  {
    name: "project 4",
    description: "this project is under construction 4",
    link: "/",
    image:
      "https://react.dev/images/og-home.png",
  },
  {
    name: "project 5",
    description: "this project is under construction 5",
    link: "/",
    image:
      "https://react.dev/images/og-home.png",
  },
  {
    name: "project 6",
    description: "this project is under construction 6",
    link: "/",
    image:
      "https://react.dev/images/og-home.png",
  },
  {
    name: "project 7",
    description: "this project is under construction 7",
    link: "/",
    image:
      "https://react.dev/images/og-home.png",
  },
  {
    name: "project 8",
    description: "this project is under construction 8",
    link: "/",
    image:
      "https://react.dev/images/og-home.png",
  },
  {
    name: "project 9",
    description: "this project is under construction 9",
    link: "/",
    image:
      "https://react.dev/images/og-home.png",
  },
];

function Portfolio() {
  return (
    <div style={{ margin: "3%", width: "100%" }}>
      <Grid container spacing={2} height="100%">
        {projects.map((item, index) => {
          return (
            <Grid key={`${item.name}--${index}`} item xs={4}>
              <Tooltip title={item.description} placement="bottom">
                <a href={item.link}>
                  <Paper
                    elevation={3}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "flex-end",
                      backgroundImage: `url(${item.image})`,
                      backgroundRepeat: "no-repeat",
                      WebkitBackgroundSize: "contain",
                      MozBackgroundSize: "contain",
                      backgroundSize: "contain",
                      height: "30vh",
                      boxShadow:
                        "0px 4px 4px 0px #00000040,inset 0 0 0 1000px rgba(0,0,0,.5)",
                    }}
                  >
                    <Typography
                      sx={{
                        height: "20%",
                        backgroundColor: "background.paper",
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        color: "info.main",
                      }}
                    >
                      {item.name}
                    </Typography>
                  </Paper>
                </a>
              </Tooltip>
            </Grid>
          );
        })}
      </Grid>
    </div>
  );
}

export default Portfolio;
